import Helper from '@ember/component/helper';
import { getOwner } from '@ember/owner';
import type { IntlService } from 'ember-intl';

export interface FormatDateTimeSignature {
  Args: {
    Positional: [string | undefined | Date];
  };
  Return: string;
}

export default class FormatDateTime extends Helper<FormatDateTimeSignature> {
  compute([date]: [string | undefined | Date]) {
    const intlService = getOwner(this)?.lookup('service:intl') as IntlService;
    return intlService.formatDate(date, {
      timeStyle: 'short',
      dateStyle: 'short',
    });
  }
}
